module.exports = __webpack_public_path__ + "static/img/teng.a9ae9941.png";